import styled from 'styled-components';

import promoColors from '../../../theme/promoColors';
import promoMedia from '../../../theme/promoMedia';
import zIndex from '../../../theme/zIndex';

// Libre page
export const LibreHeroBlock = styled.div`
    background: ${promoColors.oceanBlue01};
    margin-top: -72px;
    padding: 104px 0 80px 0;

    ${promoMedia.tablet744} {
        margin-top: -88px;
        padding: 120px 0 80px 0;
    }

    & *::selection {
        background: rgba(255, 255, 255, 0.24);
    }
`;

export const LibreButton = styled.div`
    text-align: center;
    visibility: ${(props) => (props.showFixedButton ? 'hidden' : null)};
`;

export const LibreFloatingButton = styled.div`
    position: fixed;
    bottom: 64px;
    left: 0;
    right: 0;
    height: 0;
    pointer-events: none;
    z-index: ${zIndex.bottomPanelIndex};
    text-align: right;
`;

// Request page
export const InfoHeroBlock = styled.div`
    background: ${promoColors.oceanBlue01};
    padding: 104px 0 80px 0;
    min-height: 100vh;
    box-sizing: border-box;

    ${promoMedia.tablet744} {
        padding: 120px 0 64px 0;
    }

    & *::selection {
        background: rgba(255, 255, 255, 0.24);
    }
`;
